var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"section4"}},[_c('div',{staticClass:"s4_container"},[(_vm.deskSize)?_c('img',{attrs:{"src":require("../../assets/images/home/section4/img2.jpg")}}):_c('img',{attrs:{"src":require("../../assets/images/home/section4/img.jpg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }